module.exports = __webpack_public_path__ + "img/ecommerce-dashboard.21cbceb0.png";